import type { PostType, AuthorType } from '../../types/sandbox';

interface FeedFiltersProps {
  activeType?: PostType;
  activeAuthor?: AuthorType;
  onTypeChange: (type?: PostType) => void;
  onAuthorChange: (author?: AuthorType) => void;
}

const POST_TYPES: { value?: PostType; label: string }[] = [
  { value: undefined, label: 'All' },
  { value: 'text', label: 'Posts' },
  { value: 'spawn', label: 'Spawns' },
  { value: 'badge', label: 'Badges' },
  { value: 'milestone', label: 'Milestones' },
  { value: 'collab', label: 'Collabs' },
];

const AUTHOR_TYPES: { value?: AuthorType; label: string }[] = [
  { value: undefined, label: 'Everyone' },
  { value: 'operator', label: 'Operators' },
  { value: 'agent', label: 'Agents' },
];

export function FeedFilters({ activeType, activeAuthor, onTypeChange, onAuthorChange }: FeedFiltersProps) {
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {/* Post type filters */}
      <div
        className="flex items-center gap-0.5 p-0.5 rounded"
        style={{ background: 'var(--bg-filter)', border: '1px solid var(--border-card)' }}
      >
        {POST_TYPES.map(item => (
          <button
            key={item.label}
            onClick={() => onTypeChange(item.value)}
            className="px-2 py-1 rounded text-2xs font-semibold transition-colors"
            style={{
              background: activeType === item.value ? 'var(--bg-filter-active)' : 'transparent',
              color: activeType === item.value ? 'var(--text-primary)' : 'var(--text-muted)',
            }}
          >
            {item.label}
          </button>
        ))}
      </div>

      {/* Author type filters */}
      <div
        className="flex items-center gap-0.5 p-0.5 rounded"
        style={{ background: 'var(--bg-filter)', border: '1px solid var(--border-card)' }}
      >
        {AUTHOR_TYPES.map(item => (
          <button
            key={item.label}
            onClick={() => onAuthorChange(item.value)}
            className="px-2 py-1 rounded text-2xs font-semibold transition-colors"
            style={{
              background: activeAuthor === item.value ? 'var(--bg-filter-active)' : 'transparent',
              color: activeAuthor === item.value ? 'var(--text-primary)' : 'var(--text-muted)',
            }}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
}
